import { useCallback } from "react";
import { getDrmTableData } from "../redux/reducers/drmTableDataSlice";
import { defaultFilter, pageSize } from "../helpers";
import { drmtFilterPayload } from "../constData/filterRequestPayloadDrmt";
import { drmtDailyFilterPayload } from "../constData/filterRequestPayloadDrmtDaily";

export const useDrmData = (dispatch) => {

  const refreshBid = useCallback(
    ( filter, page, tableType) => {
      if (!filter) return;

      dispatch(
        getDrmTableData({
          reqBody: filter,
          pageSize: pageSize,
          pageNum: page,
          tableName: tableType,
        })
      );
    },
    []
  );

  const handleFilterTableSearch = useCallback(
    (page, tableFilter, type, tableType) => {

      let updatedFilter;
      if ((tableType === "drmBidTableData")) {
        updatedFilter = {
          originCountry: tableFilter.originCountry,
          destinationCountry: tableFilter.destinationCountry,
          filters: tableFilter.filters,
        };
      }else{
        updatedFilter = {
          originCountries: tableFilter.originCountries,
          destinationCountries: tableFilter.destinationCountries,
          filters: tableFilter.filters,
        };
      }

      refreshBid( updatedFilter, page, tableType);
    },
    [refreshBid]
  );

  const handleClearFilterTableSearch = useCallback(
   (page, tableFilter, type, tableType) => {

      let updatedFilter;
      if ((tableType === "drmBidTableData")) {
        updatedFilter = {
          originCountry: tableFilter.originCountry,
          destinationCountry: tableFilter.destinationCountry,
          filters: drmtFilterPayload.filters,
        };
      }else{
        updatedFilter = {
          originCountries: tableFilter.originCountries,
          destinationCountries: tableFilter.destinationCountries,
          filters: drmtDailyFilterPayload.filters,
        };
      }

      refreshBid( updatedFilter, page, tableType);
    },
    [refreshBid]
  )


  return {
    refreshBid,
    handleClearFilterTableSearch,
    handleFilterTableSearch,
  };
};
